
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Criteria_for_rating_the_effect_of_general_anesthesia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Criteria_for_rating_the_effect_of_general_anesthesia.vue